/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import { ModalManager } from '../../../components/ModalManager';
import { Modal } from '../../../atoms/bootstrap/Modal';
import React from 'react';
import { useI18N } from '../../hoc/withI18N';
import { closeModal } from '../../../../actions/modals';
import { useDispatch } from 'react-redux';
import { Button } from '../../../atoms/bootstrap/Button';
import { setOrderReference } from '../../../../actions/my-puratos/checkout.action';

export const ClearCartModalId = 'clear-cart-modal';

export function ClearCartModal({ payload }) {
    const dispatch = useDispatch();
    const translate = useI18N();

    const close = React.useCallback(() => dispatch(closeModal()), [dispatch, closeModal]);

    const clearCart = () => {
        if (payload.clearCart && payload.mapping) {
            payload.clearCart({ ...payload.mapping, closeModal: true });
            dispatch(setOrderReference(''));
        }
    };

    return (
        <Modal size={Modal.sizes.MD} title={translate('Empty shopping cart')} closeModal={close}>
            <Modal.Body className="well p-modal__well">
                <p className={'p-sans-nr'}>{translate('Are you sure you want to empty your shopping cart?')}</p>
                <hr />
                <div className={'p-clear-cart-buttons'}>
                    <Button
                        color={Button.colors.SECONDARY_INVERTED}
                        onClick={clearCart}
                        className={'p-padding-left-lg p-padding-right-lg text-uppercase'}
                    >
                        {translate('yes')}
                    </Button>
                    <Button
                        color={Button.colors.SECONDARY}
                        onClick={close}
                        className={'p-padding-left-lg p-padding-right-lg text-uppercase'}
                    >
                        {translate('no')}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

ModalManager.modals[ClearCartModalId] = ClearCartModal;
